import React from 'react'

export const VolunteerEn = () => {
  return (
   <>
   <section class="fundraishing">
            <div class="fundraishing-bg-box">
                <div class="fundraishing-bg jarallax" data-jarallax data-speed="0.2" data-imgPosition="50% 0%"
                    style={{'backgroundImage':'url(images/v.jpg)'}}></div>
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-xl-12">
                        <div class="fundraishing__inner">
                            <p class="fundraishing__sub-title">Become a  Volunteer</p>
                            <h2 class="fundraishing__title">Together, we rise - become a Youth Planet <br/> volunteer</h2>
                            <div class="fundraishing__btn-box" style={{'marginBottom':'30px'}}>
                                <a href="/volunteerform" class="thm-btn fundraishing__btn">Become a Volunteer</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
   </>
  )
}
